import React from 'react';
import {
    annualizedOperatingData,
    getAnnualizedOperatingData,
    getLeaseSummaryData,
    getNetOperatingIncomeData,
    getOfferingSummaryData,
    getRentPricePercentageHeaders,
    getRentPricingData,
    leaseSummary,
    netOperatingIncome,
    offeringSummary,
    rentPricingData
} from "./tables";
import {addCommasToNumber, formatEmail} from "../../utils";

const baseUrl = 'https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/';

let cloneDeep = require('lodash.clonedeep');

export default class PrintSingleTenant extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                offeringSummary: offeringSummary,
                leaseSummary: leaseSummary,
                annualizedOperatingData: annualizedOperatingData,
                netOperatingIncome: netOperatingIncome,
                rentPricingData
            },
        }
    }

    componentDidMount() {
        if (!document.querySelector('#mapboxstyles')) {
            const link = document.createElement('link');
            link.href = 'https://api.mapbox.com/mapbox-gl-js/v2.0.0/mapbox-gl.css?optimize=true';
            link.rel = 'stylesheet';
            link.id = 'mapboxstyles';
            document.head.appendChild(link)
        }
        setTimeout(() => this.createMap(this.props.propertyMapProps), 1000);
        PrintSingleTenant.preloadStaticImages(this.props.staticImages);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.staticImages !== this.props.staticImages) {
            PrintSingleTenant.preloadStaticImages(this.props.staticImages);
        }
    }

     static preloadStaticImages(images) {
        if (!Array.isArray(images) || !images.length || typeof document === 'undefined') return;
        images.forEach(src => {
            if (!src) return;
            if (document.querySelector(`link[rel="preload"][data-static-img="1"][href="${src}"]`)) return;
            try {
                const link = document.createElement('link');
                link.rel = 'preload';
                link.as = 'image';
                link.href = src;
                link.setAttribute('data-static-img', '1');
                document.head.appendChild(link);
            } catch (e) { /* ignore */ }
        });
    }

    async componentWillReceiveProps(nextProps) {
        const data = cloneDeep(this.state.data);
        data.offeringSummary.rows =(this.props.isPropertyIndustrialVacant || this.props.isPropertyOfficeVacant || this.props.isPropertyRetailVacant ) ? getOfferingSummaryData(nextProps.tables).filter((value)=> !['Cap Rate','Net Operating Income'].includes(value.label)): getOfferingSummaryData(nextProps.tables).filter((value)=> value.label!=='Price PSF');
        data.leaseSummary.rows = getLeaseSummaryData(nextProps.tables);
        data.annualizedOperatingData.rows = getAnnualizedOperatingData(nextProps.tables);
        data.netOperatingIncome.value = getNetOperatingIncomeData(nextProps.tables);
        data.rentPricingData.rows = getRentPricingData(nextProps.tables)
        data.rentPricingData.percentageHeaders = getRentPricePercentageHeaders(nextProps.tables);

        this.setState({data});
    }


    static formatFirstLetterText(text,fontSize="26px") {
        return text.split(" ").map((word, index) => {

              if (word.includes("&")) {
                return <React.Fragment key={index}>{word} </React.Fragment>;
              }

                const firstLetter = word.charAt(0).toUpperCase();
                const restOfWord = word.slice(1);
                return (
                    <React.Fragment><span key={index} style={{ fontSize }}>{firstLetter}</span><span>{restOfWord} </span></React.Fragment>
                );
            });
    }
    


    static renderTableMatrix(table) {
        const title = PrintSingleTenant.formatFirstLetterText(table.name);
        return (
            <div className='PrintSingleTenant_content_table'>
                <div className='PrintSingleTenant_content_table_title'>{title}</div>
                {table.header ?
                    <div className='PrintSingleTenant_content_table_row'>
                        {table.header.map(cell => {
                            return (
                                <div key={cell} className='PrintSingleTenant_content_table_row_cell'>{cell}</div>
                            )
                        })}
                    </div>
                    : null
                }
                {table.rows.map((row, index) => {
                    return (
                        <div key={index} className={`PrintSingleTenant_content_table_row ${index % 2 !== 0 ? '' : 'white'}`}>
                            {row.valueCells.map((cell, cellIndex) => {
                                return (
                                    <div key={`${index}-${cellIndex}`} className='PrintSingleTenant_content_table_row_cell'>{cell.value}</div>
                                )
                            })}
                        </div>
                    )
                })}
            </div>
        )
    }


    static renderPriceRentMatrix(table) {
        return (
            <div className='PrintSingleTenant_content_table'>
                {table.percentageHeaders ?
                    <div className='PrintSingleTenant_content_table_headerrow_percentages'>
                        {table.percentageHeaders.map(cell => {
                            return (
                                <div key={cell} className='PrintSingleTenant_content_table_title percentage-rent-header'>{cell}</div>
                            )
                        })}
                    </div>
                    : null
                }
                {table.header ?
                    <div className='PrintSingleTenant_content_table_headerrow'>
                        {table.header.map(cell => {
                            return (
                                <div key={cell} className='PrintSingleTenant_content_table_title price-rent-header'>{cell}</div>
                            )
                        })}
                    </div>
                    : null
                }
                {table.rows.map((row, index) => {
                    return (
                        <div key={index} className={`PrintSingleTenant_content_table_matrix_row ${index % 2 !== 0 ? (index===3 ? 'middlerow':''): 'white'}`}>
                            {row.valueCells.map((cell, cellIndex) => {
                                return (
                                    <div key={`${index}-${cellIndex}`} className='PrintSingleTenant_content_table_matrix_row_matrixcell'>{cell.value}</div>
                                )
                            })}
                        </div>
                    )
                })}
            </div>
        )
    }

    static renderTable(table) {
        let title = PrintSingleTenant.formatFirstLetterText(table.name);
        return (
            <div className={`PrintSingleTenant_content_table ${table.value ? 'no-margin' : ''}`}>
                {table.value ?
                    <div className='PrintSingleTenant_content_table_one_row'>
                        <div className='PrintSingleTenant_content_table_title'>{title}</div>
                        <div className='PrintSingleTenant_content_table_value'>{table.value}</div>
                    </div>
                    :
                    <div className='PrintSingleTenant_content_table_title'>{title}</div>
                }
                {table.rows ?
                    table.rows.map((row, index) => {
                        return (
                            <div key={index} className={`PrintSingleTenant_content_table_column ${index % 2 !== 0 ? 'white' : ''} ${table.rows.length - 1 === index && index % 2 === 0 ? 'last-row' : ''}`}>
                                <div>{row.label}</div>
                                <div>{row.value}</div>
                            </div>
                        )
                    })
                    : null
                }
            </div>
        );
    }

    getCapValue (index,isPsf) {
        const rowType = isPsf ? 'sale-price-psf':'cap-rate';
        return this.props.tables['pricing-matrix'].rows[rowType].valueCells[index].getComputedValue(this.props.tables).displayValue || '0';
    }

    async createMap(propertyMapProps) {
        let {default: mapboxgl} = await import('mapbox-gl/dist/mapbox-gl.js');

        mapboxgl.accessToken = 'pk.eyJ1IjoiYW5kcmVlYW1pcmNlYSIsImEiOiJja2lpa25rNzQwYWV0MnNxcGdscDVnbGc3In0.YW3ma8Gr7xlYFsAfLwTL1A';
        let map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [propertyMapProps.LONGITUDE, propertyMapProps.LATITUDE],
            zoom: 12,
            minzoom: 12,
            maxzoom: 12,
        });

        let el = document.createElement('div');
        el.className = 'marker';
        el.style.backgroundImage = `url(${arc.path.media}marker-star.svg)`;

        new mapboxgl.Marker(el).setLngLat([propertyMapProps.LONGITUDE, propertyMapProps.LATITUDE])
            .addTo(map);

        const propertyName = propertyMapProps.NAME;
        new mapboxgl.Popup()
            .setLngLat([propertyMapProps.LONGITUDE, propertyMapProps.LATITUDE])
            .setHTML(propertyName)
            .addTo(map);
    }

    render() {
        const { isPropertyIndustrialVacant, isCategoryOffice ,isPropertyOfficeVacant,isPropertyRetailVacant, isPropertyIndustrial, isSaleLeaseBack} = this.props;
        const isPricingAnalysisMarketingProposal = isPropertyIndustrialVacant || isPropertyOfficeVacant || isPropertyRetailVacant ;
        const vacantProperty = isPropertyIndustrialVacant || isPropertyOfficeVacant || isPropertyRetailVacant;
        const data = this.state.data;
        const agents = this.props.agents;
        const name = this.props.tables['general-information'].rows['property-name'].value;
        const address = this.props.tables['general-information'].rows['address'].value;
        const city = this.props.tables['general-information'].rows['city'].value;
        const state = this.props.tables['general-information'].rows['state'].value;
        const zip = this.props.tables['general-information'].rows['zip'].value;
        const photo = this.props.propertyImage ? this.props.propertyImage.includes('https') ? this.props.propertyImage : arc.path.media + this.props.propertyImage : '';
        const PriceRange = isPricingAnalysisMarketingProposal ? 'https://strivenext.s3.amazonaws.com/website/events/STNL_industrial_Pricing_Range_1_NEW.png' : 'https://strivenext.s3.amazonaws.com/website/events/Pricing_Range_Analysis_Image_2_83kxo.png';
        const aggressive = this.props.tables['pricing-matrix'].rows['value'].valueCells[1].getComputedValue( this.props.tables).internalValue || '0';
        const anticipated = this.props.tables['pricing-matrix'].rows['value'].valueCells[2].getComputedValue( this.props.tables).internalValue || '0';
        const conservative = this.props.tables['pricing-matrix'].rows['value'].valueCells[3].getComputedValue( this.props.tables).internalValue || '0';
        const aggressive_cap = this.getCapValue(1, isPricingAnalysisMarketingProposal);
        const anticipated_cap = this.getCapValue(2, isPricingAnalysisMarketingProposal);
        const conservative_cap = this.getCapValue(3, isPricingAnalysisMarketingProposal);
        const yearBuilt = this.props.tables['offering-summary'].rows['year-built'].value || '-';
        const noi = this.props.tables['offering-summary'].rows['net-operating-income'].getComputedValue( this.props.tables).displayValue || '-';
        const lot_size = this.props.tables['offering-summary'].rows['lot-size'].value || '0';
        const Strengths = this.props.proposalData.strengths || '';
        const challenges = this.props.proposalData.challenges || '';
        const buyerPool = this.props.proposalData.buyer_pool || '';
        const qualifications = this.props.proposalData.qualifications || '';
        const recommendations = this.props.proposalData.recommendations || '';
        const lease_types = this.props.tables['lease-summary'].rows['lease-type'].value || '-';
        const isLeaseTypeGround = this.props.tables['lease-summary'].rows['lease-type'].value == "Ground";
        const gla = this.props.tables['offering-summary'].rows['gross-leasable-area'].value || '-';
        let photo1Url;
        if (isPropertyIndustrialVacant || isPropertyIndustrial) {
            photo1Url = 'https://strivenext.s3.amazonaws.com/website/events/STNL_industrial_vacant_image_1_7xH7l.jpg';
        } else if (isCategoryOffice) {
            photo1Url = 'https://strivenext.s3.amazonaws.com/website/events/Office_image_1_qVIoT.jpg';
        } else {
            photo1Url = 'https://strivenext.s3.amazonaws.com/website/events/STNL_image_1.jpg';
        }
               
        if (data && data.annualizedOperatingData && data.annualizedOperatingData.rows.length>12 && this.props.propertyImage) {
            data.annualizedOperatingData.rows.splice(12);
        }
       
        return (
            <div className='SingleTenant'>
                {(this.props.isCategoryRetail || isPropertyIndustrialVacant || isCategoryOffice || isPropertyIndustrial) ? <div className='content' style={{ position: 'relative', padding: 0 }}>
                    <img src={`${photo1Url}`} />
                    <div className='bottom-section' style={{ color: 'white', position: 'absolute', left: "6%", bottom: "2%" }}>
                        <div className='address' style={{ fontSize: "25px", lineHeight: "40px" }}>Pricing Analysis & Marketing Proposal</div>
                        <div className='name' style={{ fontSize: "45px", lineHeight: "40px", fontWeight:'bold'}}>{name}</div>
                        <div className='address' style={{ fontSize: "35px", lineHeight: "40px" }}>{`${city}, ${state}`}</div>
                    </div>
                </div> : null}
            <div className='PrintSingleTenant' style={{backgroundImage: `url('${arc.path.media+'stnl-background.png'}')`}}>
                <div className='PrintSingleTenant_head'>
                    <div className='PrintSingleTenant_head_logo'>
                        <img src={arc.path.media+'strive-logo.png'} alt=''/>
                    </div>
                </div>
                <div className="parent">
                    <div className="horizontal first">
                        <div className='PrintSingleTenant_content_name'>{name}</div>
                    </div>
                    <div className="horizontal second">
                        <div className="vertical left">
                            <div className='PrintSingleTenant_content_address'>{address}</div>
                            <div className='PrintSingleTenant_content_address'>{`${city}, ${state} ${zip}`}</div>
                            {PrintSingleTenant.renderTable(data.offeringSummary)}
                            {!isPricingAnalysisMarketingProposal && PrintSingleTenant.renderTable(data.leaseSummary)}
                        
                        </div>
                        <div className="vertical right">
                        {

                            this.props.propertyImage && !isPricingAnalysisMarketingProposal && !isSaleLeaseBack &&
                            <div className='PrintSingleTenant_content_image'>
                                {photo && <img src={photo} alt=''/>}
                            </div>  
                        }
                        {
                            (isPricingAnalysisMarketingProposal || isSaleLeaseBack) &&
                            <div id='map'/>
                        }
                        {!isPricingAnalysisMarketingProposal && PrintSingleTenant.renderTableMatrix(data.annualizedOperatingData)}
                        {!isPricingAnalysisMarketingProposal && PrintSingleTenant.renderTable(data.netOperatingIncome)}
                        </div>
                    </div>
                </div>
{/* 
                <div className='PrintSingleTenant_content'>
                    <div className='PrintSingleTenant_content_left'>
                        <div className='PrintSingleTenant_content_name'>{name}</div>
                        <div className='PrintSingleTenant_content_address'>{address}</div>
                        <div className='PrintSingleTenant_content_address'>{`${city}, ${state} ${zip}`}</div>
                        {PrintSingleTenant.renderTable(data.offeringSummary)}
                        {!isPricingAnalysisMarketingProposal && PrintSingleTenant.renderTable(data.leaseSummary)}
                    </div>
                    <div className='PrintSingleTenant_content_right'>
                        {this.props.propertyImage && !isPricingAnalysisMarketingProposal?
                            <div className='PrintSingleTenant_content_image'>
                                <img src={photo} alt=''/>
                            </div>
                            :
                            isPricingAnalysisMarketingProposal ?
                            <div id='map'/>
                            : null
                        }
                        {!isPricingAnalysisMarketingProposal && PrintSingleTenant.renderTableMatrix(data.annualizedOperatingData)}
                        {!isPricingAnalysisMarketingProposal && PrintSingleTenant.renderTable(data.netOperatingIncome)}
                    </div>
                </div> */}
                {
                isPricingAnalysisMarketingProposal &&
                    <div className='PrintSingleTenant_coverimage'>
                       {photo && <img src={photo} alt=''/>}
                    </div>
                }
                <div className='PrintSingleTenant_footer'>
                    {agents && agents.length ?
                        agents.map(agent => {
                            return (
                                <div key={agent.id}>
                                    <div className='PrintSingleTenant_footer_name'>{agent.name}</div>
                                    <div className='PrintSingleTenant_footer_details'>
                                        <div>{agent.phone}</div>
                                        <div className={agent.email ? 'PrintSingleTenant_footer_line' : ''}/>
                                        <div>{agent.email? formatEmail(agent.email): ''}</div>
                                    </div>
                                </div>
                            )
                        }) : null
                    }
                </div>
            </div>
                {
                    isSaleLeaseBack &&
                    (
                        <div className='PrintSingleTenant' style={{ backgroundImage: `url('${arc.path.media + 'stnl-background.png'}')` }}>
                            <div className='PrintSingleTenant_head'>
                                <div className='PrintSingleTenant_head_logo'>
                                    <img src={arc.path.media + 'strive-logo.png'} alt='' />
                                </div>
                            </div>
                            <div className="parent">
                                <div className="horizontal first">
                                    <h2 style={{ color: "white" }}>{PrintSingleTenant.formatFirstLetterText("RENT & PRICING RANGE", "32px")}</h2>
                                </div>
                                <div className="horizontal first">
                                    <div className="vertical-full" style={{width:"90%",margin:"0 auto"}}>
                                        {PrintSingleTenant.renderPriceRentMatrix(data.rentPricingData)}
                                    </div>
                                </div>
                            </div>
                            <div className='PrintSingleTenant_coverimage rent-pricing'>
                                {photo && <img src={photo} alt='' />}
                            </div>
                            <div className='PrintSingleTenant_footer'>
                                {agents && agents.length ?
                                    agents.map(agent => {
                                        return (
                                            <div key={agent.id}>
                                                <div className='PrintSingleTenant_footer_name'>{agent.name}</div>
                                                <div className='PrintSingleTenant_footer_details'>
                                                    <div>{agent.phone}</div>
                                                    <div className={agent.email ? 'PrintSingleTenant_footer_line' : ''} />
                                                    <div>{agent.email ? formatEmail(agent.email) : ''}</div>
                                                </div>
                                            </div>
                                        )
                                    }) : null
                                }
                            </div>
                        </div>
                    )
                }
            {(this.props.isCategoryRetail || isPropertyIndustrialVacant || isCategoryOffice || isPropertyIndustrial)? <div className="page" style={{ height: 'auto', padding: 0 }}>

                        <div className='content' style={{ position: 'relative', padding: 0 }}>
                            <img className='valueAnalysis' style={{height: "810px"}} src={`${PriceRange}`} />

                            <div className='value-analysis-section'>
                                <div className='conservative' style={{position: "fixed", lineHeight: "10px", textAlign: "center", marginLeft: "205px", width: "180px", fontFamily: "GothamBook"}}>
                                    <p>${addCommasToNumber(conservative)}</p>
                                    <p>{conservative_cap} {isPricingAnalysisMarketingProposal ? 'PSF':'Cap'}</p>
                                </div>
                                <div className='anticipated' style={{position: "fixed", lineHeight: "10px",textAlign:"center", marginLeft: "420px", width:"180px", fontFamily: "GothamBook"}}>
                                    <p>${addCommasToNumber(anticipated)}</p>
                                    <p>{anticipated_cap} {isPricingAnalysisMarketingProposal ? 'PSF':'Cap'}</p>
                                </div>
                                <div className='aggressive' style={{position: "fixed", lineHeight: "10px", textAlign: "center", marginLeft: "625px", width: "180px", fontFamily: "GothamBook"}}>
                                    <p>${addCommasToNumber(aggressive)}</p>
                                    <p>{aggressive_cap} {isPricingAnalysisMarketingProposal ? 'PSF':'Cap'}</p>
                                </div>
                            </div>
                            <div className='value-analysis-section-2' style={{ top: '50%', fontSize: '22px', fontFamily: "Gotham", textAlign: "Center" }}>
                            <div className="yearBuilt" style={{ position: "fixed", marginLeft: (isPropertyIndustrialVacant || isPropertyOfficeVacant || isPropertyRetailVacant)? "200px" :"70px", width: "200px", lineHeight: "15px" }}>
                                <p className='titles'>YEAR BUILT</p>
                                <p style={{ fontFamily: "GothamBook" }}>{yearBuilt}</p>
                            </div>
                            {
                                !vacantProperty?
                                    <React.Fragment>
                                        <div className="noi" style={{ position: "fixed", marginLeft: "308px", width: "200px", lineHeight: "15px" }}>
                                            <p className='titles'>NOI</p>
                                            <p style={{ fontFamily: "GothamBook" }}>{addCommasToNumber(noi)}</p>
                                        </div>
                                        <div className="lease_types" style={{ position: "fixed", marginLeft: "525px", width: "200px", lineHeight: "15px" }}>
                                            <p className='titles'>{"LEASE TYPE"}</p>
                                            <p style={{ fontFamily: "GothamBook" }}>{isLeaseTypeGround == true ? "Ground Lease" : lease_types}</p>
                                        </div>
                                    </React.Fragment> :
                                    <React.Fragment>
                                        <div className="lease_types" style={{ position: "fixed", marginLeft: "420px", width: "200px", lineHeight: "15px" }}>
                                            <p className='titles'>GLA</p>
                                            <p style={{ fontFamily: "GothamBook" }}>{addCommasToNumber(gla)} SF</p>
                                        </div>
                                    </React.Fragment>
                            }
                            <div className="lot_size" style={{ position: "fixed", marginLeft: (isPropertyIndustrialVacant || isPropertyOfficeVacant || isPropertyRetailVacant) ? "625px":"760px", width: "200px", lineHeight: "15px" }}>
                                <p className='titles'>LOT SIZE</p>
                                <p style={{ fontFamily: "GothamBook" }}>{lot_size} Acres </p>
                            </div>
                            </div>
                            <div className='value-analysis-section-3'>
                                <div className="Strengths">
                                    {Strengths.split('\n').splice(0, 3).map(res => {

                                        return (
                                            <ul className="list">
                                                <li>{res}</li>
                                            </ul>)
                                    })}
                                </div>
                                <div className="challenges">
                                    {challenges.split('\n').splice(0, 3).map(res => {

                                        return (
                                            <ul className="list">
                                                <li>{res}</li>
                                            </ul>)
                                    })}
                                </div>
                                <div className="buyerPool">
                                    {buyerPool.split('\n').splice(0, 3).map(res => {

                                        return (
                                            <ul className="list">
                                                <li>{res}</li>
                                            </ul>)
                                    })}
                                </div>
                                <div className="qualifications">
                                    {qualifications.split('\n').splice(0, 5).map(res => {
                                        return (
                                            <ul className="list">
                                                <li>{res}</li>
                                            </ul>)
                                    })}
                                </div>
                                <div className="recommendations">
                                    {recommendations.split('\n').splice(0, 2).map(res => {

                                        return (
                                            <ul className="list">
                                                <li>{res}</li>
                                            </ul>)
                                    })}
                                </div>
                            </div>
                        </div>
            </div>: null}
            {
                    this.props.staticImages.map((img, index) => {
                        return (this.props.isCategoryRetail || isPropertyIndustrialVacant || isCategoryOffice || isPropertyIndustrial) ? (<React.Fragment key={`${img}-${index}`}>
                        <div className="PrintSingleTenant" style={{ height: 'auto', padding: 0 }}>
                                <div className='content' style={{ position: 'relative', padding: 0 }}>
                                    <img
                                        className='staticImg'
                                        src={`${img}`}
                                        alt=''
                                        loading='eager'
                                        width={960}
                                        height={810}
                                    />
                                </div>
                            </div>
                        </React.Fragment>) : null
                    })
                }
            </div>
        )

        
    }
}